import { render, staticRenderFns } from "./RxTime.vue?vue&type=template&id=ce2736d4"
import script from "./RxTime.vue?vue&type=script&lang=js"
export * from "./RxTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports